export default __webpack_public_path__ + "static/media/img-service2u-icon.4a716ae1.svg";